import React, { useEffect } from "react";
import { useFormik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import { BiX } from "react-icons/bi";
import { BsCheck } from "react-icons/bs";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import SelectInput from "../../../components/UI/SelectInput/SelectInput";
import SelectFlag from "../../../components/UI/SelectInput/SelectInputFlags";
import SelectSituacao from "../../../components/UI/SelectInput/SelectSituacao";
import SelectTipoCarga from "../../../components/UI/SelectInput/SelectTipoCargaFormik";
import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";

const columns = [
  {
    name: "Nome",
    selector: "nomeProcedimento",
    maxWidth: "50%",
    sortable: true,
  },
  {
    name: "Carga",
    selector: "nomeCarga",
    width: "200px",
    center: true,
    sortable: true,
  },
  {
    name: "Situação",
    selector: "stProcDescricao",
    width: "8%",
    center: true,
    sortable: true,
  },
  {
    name: "SEFISC",
    // selector: 'fgSefiscDescricao',
    cell: (row) => {
      if (row.fgSefisc === "S") {
        return (
          <Button variant="bg-transparent" className="btn-lg text-success pa-0 p-0">
            {" "}
            <BsCheck />
          </Button>
        );
      }

      return (
        <Button variant="bg-transparent" className="btn-lg text-danger pa-0 p-0">
          {" "}
          <BiX />
        </Button>
      );
    },
    width: "8%",
    center: true,
  },
  {
    name: "Diligência",
    cell: (row) => {
      if (row.fgDiligencia === "S") {
        return (
          <Button variant="bg-transparent" className="btn-lg text-success pa-0 p-0">
            {" "}
            <BsCheck />
          </Button>
        );
      }

      return (
        <Button variant="bg-transparent" className="btn-lg text-danger pa-0 p-0">
          {" "}
          <BiX />
        </Button>
      );
    },
    width: "8%",
    center: true,
  },
  {
    name: "Auditoria Específica",
    cell: (row) => {
      if (row.fgAudEspecifica === "S") {
        return (
          <Button variant="bg-transparent" className="btn-lg text-success pa-0 p-0">
            {" "}
            <BsCheck />
          </Button>
        );
      }

      return (
        <Button variant="bg-transparent" className="btn-lg text-danger pa-0 p-0">
          {" "}
          <BiX />
        </Button>
      );
    },
    width: "8%",
    center: true,
  },
  {
    name: "Monitoramento",
    cell: (row) => {
      if (row.fgMonitoramento === "S") {
        return (
          <Button variant="bg-transparent" className="btn-lg text-success pa-0 p-0">
            {" "}
            <BsCheck />
          </Button>
        );
      }

      return (
        <Button variant="bg-transparent" className="btn-lg text-danger pa-0 p-0">
          {" "}
          <BiX />
        </Button>
      );
    },
    width: "10%",
    center: true,
  },
];

const validationSchema = Yup.object().shape({
  sqTipoCarga: Yup.string().default(""),
  flagStProcedimento: Yup.string().default(""),
  fgSefisc: Yup.string().default(""),
  tipoAcaoFiscal: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ConsultaProcedimento = ({ history, match }) => {
  const { advancedSearchParameters } = useSelector((state) => state.advancedSearch);

  const formik = useFormik({ initialValues, validationSchema });

  const { setValues } = formik;

  useEffect(() => {
    if (Object.keys(advancedSearchParameters).length !== 0) {
      setValues({ ...advancedSearchParameters });
    }
  }, [setValues, advancedSearchParameters]);

  return (
    <PaginatedView
      title="Procedimentos"
      keyField="sqProcedimento"
      descriptionField="nomeProcedimento"
      defaultSearch
      defaultSearchPlaceholder="Digite o Nome"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultaProcedimento}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiProcedimento}
      editRoute={`${match.url}/form`}
      columns={columns}
      advancedSearchFormik={formik}
      permissionDelete={funcionalidades.procedimentoFiscal.deletar}
      permissionInsert={funcionalidades.procedimentoFiscal.inserir}
      history={history}
      reduxKey="procedimentos"
    >
      <Row>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Tipo Carga</Form.Label>
          <SelectTipoCarga formik={formik} field="sqTipoCarga" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Situação</Form.Label>
          <SelectSituacao formik={formik} field="flagStProcedimento" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>SEFISC</Form.Label>
          <SelectFlag formik={formik} field="fgSefisc" />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={3}>
          <Form.Label>Tipo Ação Fiscal</Form.Label>
          <SelectInput
            formik={formik}
            field="tipoAcaoFiscal"
            options={[
              { key: "0", value: "", text: "Selecione" },
              { value: "D", text: "DILIGENCIA" },
              { value: "A", text: "AUDITORIA ESPECÍFICA" },
              { value: "M", text: "MONITORAMENTO" },
            ]}
          />
        </Form.Group>
      </Row>
    </PaginatedView>
  );
};

export default ConsultaProcedimento;
